<template>
  <div class="container">

    <div class="top-wrap">
      <!-- 前一个 -->
      <div class="arrow show-flex-c arrow_prev" @click="toggleCanv('prev')">
        <img src="../../static/img/arrow_left.png" alt="">
        <!-- <span></span> -->
      </div>

      <!-- 图片裁剪 -->
      <div class="clipWrap">
        <!-- <div class="img-canvas" id="clipArea1"
          v-show="propList.length >= 1 && currentIndex == 1"></div>
        <div class="img-canvas" id="clipArea2"
          v-show="propList.length >= 2 && currentIndex == 2"></div>
        <div class="img-canvas" id="clipArea3"
          v-show="propList.length >= 3 && currentIndex == 3" ></div> -->

          <div class="img-canvas" id="clipArea1"
            :class="{ 'img-can-show' : propList.length >= 1 && currentIndex == 1}"></div>
          <div class="img-canvas" id="clipArea2"
            :class="{ 'img-can-show' : propList.length >= 2 && currentIndex == 2}"></div>
          <div class="img-canvas" id="clipArea3"
            :class="{ 'img-can-show' : propList.length >= 3 && currentIndex == 3}"></div>
      </div> 

      <!-- 后一个 -->
      <div class="arrow show-flex-c arrow_next" @click="toggleCanv('next')">
        <img src="../../static/img/arrow_right.png" alt="">
        <!-- <span></span>         -->
      </div>

      <div class="canv-num">
        <span>{{currentIndex}}</span><span>/</span><span>{{propList.length}}</span>
      </div>

    </div>

    <!-- 文字输入层 -->
    <div class="word-input-wrap hide">
      <div class="bg" @click="inpReset"></div>
      <textarea autofocus maxlength="8" id="textInp" ref="textArea"></textarea>
      <div class="text-confirm-wrap">
        <div class="text-confirm show-flex-c" @click="inpConfirm">确认</div>
      </div>
    </div>

    <!-- 文字输入之后 显示层 -->
    <div class="canv_top" id="wordShowParent">
      <div class="word-show word-show-h show-flex-c">
        <div class="word-cont font-one">{{wordCont}}</div>
      </div>
    </div>
		
    <!-- 输入文字块 -->
    <div class="word-wrap" @click="inputWord">
      <input type="text" placeholder="编辑文字" :value="curText" readonly>
    </div>

    <!-- 调节速度块 -->
    <div class="speed-wrap show-flex-b">
      <div class="line"></div>
      <div class="s-item show-flex-c" @click="preview('slow')">
        <div :class="{'cbutton':durType=='slow' && tap}"></div>
        <img v-if="durType=='slow'" class="play-btn" src="../../static/img/play.png">        
      </div>
      <div class="s-item show-flex-c" @click="preview('standard')">
        <div :class="{'cbutton':durType=='standard' && tap}"></div>
        <img v-if="durType=='standard'" class="play-btn" src="../../static/img/play.png">
      </div>
      <div class="s-item show-flex-c" @click="preview('fast')">
        <div :class="{'cbutton':durType=='fast' && tap}"></div>
        <img v-if="durType=='fast'" class="play-btn" src="../../static/img/play.png">        
      </div>
    </div>
    <div class="speed-word show-flex-b">
      <div class="w-item"
        :class="{'w-active':durType=='slow'}"
        @click="preview('slow')">慢</div>
      <div class="w-item"
        :class="{'w-active':durType=='standard'}"
        @click="preview('standard')">标准</div>
      <div class="w-item"
        :class="{'w-active':durType=='fast'}"
        @click="preview('fast')">快</div>
    </div>

    <div class="finish-btn" id="clipBtn"
      @click="finishEdit">
      <div>完成</div>
    </div>

    <!-- 生成表情loading -->
    <div class="loading show-flex-c" v-if="loading">
      <img src="../../static/img/loading.gif" alt="">
      <span>正在生成表情</span>
    </div>

    <!-- 加载图片loading -->
    <div class="loading show-flex-c" v-if="loading_img">
      <img src="../../static/img/loading.gif" alt="">
      <span>正在加载图片</span>
    </div>
  </div>
</template>

<script>
import { baseUrl, imgUrl } from "../../static/util/domain";
import 'url-search-params-polyfill';

let img64Url_1 =''; //base64 图片地址
let img64Url_2 =''; //base64 图片地址
let img64Url_3 =''; //base64 图片地址
let content = ''; //输入的文字
let _type = 0;    //0静态   1动态
let play_count = 0;//播放次数

export default {
  name: 'ExpressionMany',
  data () {
    return {
      propList:[{info:''}],//小程序传过来的图片
      canvList:[],//画面list
      // bqCode:'AAF5F08393B6C2BE', //比趣code
      bqCode:'', //比趣code
      currentIndex: 1,//当前index
      wordCont:'',//显示文字
      timer:null,
      loading:false,//生成表情
      loading_img:true,//加载图片
      durType:'standard',//速度
      btnDisable:false,//禁止点击
      tap:false,//点击
      pIds:'',//
      wordShow:false,//输入文字层
    }
  },
  created () {
    let arr = [];
    let proQuery = this.$route.query;
    
    this.bqCode = proQuery.bqCode || 'AAF5F08393B6C2BE';
    let pIds = proQuery.picIds || '566791,566794,574080';
    
    console.log(pIds);
    console.log(typeof pIds)

    // if(typeof proQuery.pIds != 'string'){
    //   this.propList = [
    //     {
    //       info:"",
    //       url:"https://running.osports.cn/biqu/upload/images/20180413/0f13aa7ba865461c8de028c551bda356-thumb.jpg",
    //       id:566791
    //     },{
    //       info:"",
    //       url:"https://running.osports.cn/biqu/upload/images/20180413/f1a5c9ed46d2453187f72ae6fd725748-thumb.jpg",
    //       id:566794
    //     },{
    //       info:"",
    //       url:"https://running.osports.cn/biqu/upload/images/20180416/8668fa2f1f554fe5a2afe88082234fb0-thumb.jpg",
    //       id:574080
    //     }
    //   ]
    //   setTimeout(()=>{
    //     this.imgCanv();
    //   },300)
    //   return;
    // }

    let pIdArr = pIds.split(",");

    console.log(pIdArr)

    this.pIdArr = pIdArr;


    this.getImg();
  },
  mounted(){
    let qu = this.$route.query;
    console.log(qu)

    try{
      this.bqCode = qu.bqCode || this.bqCode;
    }finally{
      setTimeout(()=>{
        // this.imgCanv();
      },300)
    }
  },
  computed: {
    // a computed getter
    // `this` points to the vm instance

    curText: function () {
      let info = '';
      try{
        info = this.propList[this.currentIndex-1].info || '编辑文字'
      }finally{
        return info;
      }
    }
  },
  methods:{
    
    // 切换CANVAS
    toggleCanv(direction = 'next'){
      //改变单张图对应的字
      // this.wordCont='';
      if(this.currentIndex == 1){
        this.wordCont == this.propList[0].info;
      }

      if(direction.indexOf('next') !=-1){//下一个
        if(this.currentIndex == this.propList.length){
          // alert('已经是最后一张了');
          // this.previewInit();
          this.currentIndex = 0;
          this.wordCont == this.propList[0].info;
          // return;
        }
        
          this.wordCont = this.propList[this.currentIndex].info;
          this.currentIndex++;
        // if(play_count){
        //   this.previewInit();
        //   this.toggleCanv();
        // }else{
        //   this.wordCont = this.propList[this.currentIndex].info;
        //   this.currentIndex++;
        // }
        
      }else{//上一个
        if(this.currentIndex == 1){
          // alert('已经是第一张了');
          return;
        }
        this.wordCont = this.propList[this.currentIndex-2].info;
        this.currentIndex--;
      }
    },

    previewInit(){
      this.currentIndex = 1;
      this.wordCont = this.propList[0].info;
    },
    //预览
    preview(speed = 'standard'){
      this.previewInit();
      this.tap = true;
      setTimeout(()=>{
        this.tap = false;
      },500);

      this.durType = speed;

      let time = 1000;

      if(speed.indexOf('slow') != -1){//慢速
        time = 1500;
      // }else if(speed.indexOf('standard') != -1){//标准
      }else if(speed.includes('standard')){//标准
        time = 1000;
      }else{//快速
        time = 500;
      }
      
      clearInterval(this.timer);
      play_count = 0;//播放次数
      this.timer = setInterval(()=>{
        if(this.currentIndex == this.propList.length){
          play_count++;        
        }
        if(this.currentIndex == this.propList.length && play_count>=2){
          console.log('end')
          clearInterval(this.timer);
          // return;
        }

        this.toggleCanv();

      },time);




    },
    getImg(){
      let params = new URLSearchParams();

      for (const item of this.pIdArr) {
        params.append('picIds', item);
      }
      params.append('bqCode', this.bqCode);
      
      this.$http.post('/multiple/pictures/detail',params)
      .then( res => {
        let d = res.data;
        if(d.result){
          let arr = [];
          for(let item of d.list){
            let obj ={};
            obj['id'] = item.id;
            obj['url'] = imgUrl(item.thumbUrl);
            obj['info'] = '';

            arr.push(obj);
          }

          this.propList = arr;
          
          this.imgCanv();
        }else{

        }
      })
      .catch( err => {
        console.log(err);
      })
    },
    //初始化截图
    imgCanv(){
      try{

      
      let w = $('#clipArea1').width();
      let h = $('#clipArea1').height();
      
      let self = this;
      
      let src1= this.propList[0].url;
      let src2= this.propList[1].url;
      


      let pc = new PhotoClip('#clipArea1', {
        size:[w,w],
        // outputSize: 200,
        outputQuality: 0.8,
        img: src1,
        view: "#view",
        ok: "#clipBtn",
        maxZoom:4,
        loadStart: function () {
          // $(".loading_middle").show();
          self.loading_img = true;          
        },
        loadComplete: function () {
          // $(".loading_middle").hide();
          self.loading_img = false;
        },
        done: function (dataURL1) {
          img64Url_1 = dataURL1;
        },
        fail: function(msg) {
          alert(msg);
        }
      });

      let pc2 = new PhotoClip('#clipArea2', {
        size:[w,w],
        // outputSize: 200,
        outputQuality: 0.8,
        img: src2,
        view: "#view",
        ok: "#clipBtn",
        maxZoom:4,
        loadStart: function () {
          // $(".loading_middle").show();
        },
        loadComplete: function () {
          // $(".loading_middle").hide();
        },
        done: function (dataURL1) {
          img64Url_2 = dataURL1;
        },
        fail: function(msg) {
          alert(msg);
        }
      });

      if(this.propList.length == 2){
        return;
      }

      let src3= this.propList[2].url;
      let pc3 = new PhotoClip('#clipArea3', {
        size:[w,w],
        // outputSize: 200,
        outputQuality: 0.8,
        img: src3,
        view: "#view",
        ok: "#clipBtn",
        maxZoom:4,
        loadStart: function () {
          // $(".loading_middle").show();
        },
        loadComplete: function () {
          // $(".loading_middle").hide();
        },
        done: function (dataURL1) {
          img64Url_3 = dataURL1;
        },
        fail: function(msg) {
          alert(msg);
        }
      });

      }catch(err){
        console.log(err);
      }
    },

    //输入取消
    inpReset(){
      $('.word-input-wrap').hide();    
      this.wordShow = false;  
    },
    //输入 确认
    inpConfirm(){
      content = $('#textInp').val().replace(/[\r\n\s]/g,"");
      let html= $('#textInp').val().replace(/\n/g, '').replace(/\r/g, '');
      
      this.propList[this.currentIndex - 1].info = content;
      this.wordCont = content;
      
      $('#textInp').val('');

      this.$nextTick(()=>{
        this.inpReset();
      })
      

    },
    //输入显示
    inputWord(){
      this.wordShow = true;
      $('.word-input-wrap').show();
      $('#textInp').focus().val(this.propList[this.currentIndex - 1].info);
    },

    //生成表情
    //完成编辑
    finishEdit(){
      this.loading = true;

      let bqCode = this.bqCode;
      let pl = this.propList;

      const url = '/make/gif/multiple/pictures';
      let picIds = [];
      let contents = [];
      let durType = this.durType;


      let params = new URLSearchParams();


      for (const item of pl) {
        // picIds.push(item.id);
        // contents.push(item.info);
        params.append('picIds', item.id);
        params.append('contents', item.info);
      }

      

      
      setTimeout(()=>{
        let picSrcs = [img64Url_1,img64Url_2,img64Url_3];

        for(const item of picSrcs){
          params.append('picSrcs', item);
        }
        params.append('bqCode', bqCode);
        params.append('durType', durType);

        this.$http.post(url,params)
          .then( res => {
            let d = res.data;
            if(d.result){
              let {gifUrl,id} = d;
              this.$router.push({
                path:'ExpressionView',
                query:{
                  gifUrl,
                  id
                }
              })
            }else{}
            this.loading = false;
          })
          .catch( err => {
            this.loading = false;
          })
      },0)

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.container{
  font-size: .28rem;
  color: #808080;
}
.top-wrap{
  padding: .4375rem 1rem .828125rem;
  background: #fafafa;
  border-bottom: .015625rem solid #e1e1e1;
  position: relative;
}
.img-canvas{
  width: 8rem;
  height: 8rem;
  overflow: hidden;
  background: #f5f5f5;
  left: 100%;
  position: absolute!important;
}
.clipWrap{
  width: 8rem;
  height: 8rem;
  position: relative;
  overflow: hidden;
}
.img-can-show{
  left: 0;
}
.canv-num{
  position: absolute;
  bottom: .34375rem;
  text-align: center;
  width: 100%;
  left: 0;
  font-size: .34375rem;
  color: #999;
}
.arrow{
  text-align: center;
  width: .625rem;
  height: .9375rem;
  position: absolute;
  top: 3.90625rem;
  background: rgba(0, 0, 0, .5);
  z-index: 3;
}
.arrow_prev{
  left: 1rem;
}
.arrow_next{
  right: 1rem;
}
/* .arrow::before{
  display:inline-block;
  height:100%; 
  vertical-align:middle;
} */
.arrow>img{
  width: .25rem;
}
.word-wrap{
  font-size: .375rem;
  margin: .375rem auto 0;
  padding: 0 1rem;
  color: #ccc;
}
.word-wrap > input {
  background: #f5f5f5;
  border-radius: .140625rem;
  padding: 0 .15625rem;
  line-height: 1.03125rem;
  border: 0;
  width: 100%;
  color: #ccc;
  top: 0.9rem;
}

.word-confirm{
    display: inline-block;
    padding: 0 .2rem;
    background: #5ce80c55;
    color: #fff;
}
.speed-wrap{
  overflow: hidden;
  height: 1.828125rem;
  position: relative;
  width: 100%;
  padding: 0 1rem;
  margin-top: .625rem;
}
.speed-wrap .s-item{
 width: .375rem;
 height: .375rem;
 background: #dcdcdc;
 border-radius: 50%;
 overflow: visible;
}
.play-btn{
  width: 1.828125rem;
}
.speed-wrap .line{
  position: absolute;
  left: 1rem;
  right: 1rem;
  height: .03125rem;
  background: #dcdcdc;
  z-index: -1;
}
.speed-word{
  padding: .125rem 1rem 0;
  font-size: .375rem;
}
.finish-btn{
  color: #fff;
  font-size: .34375rem;
  display: table;
  width: 1.875rem;
  height: .78125rem;
  text-align: center;
  margin: .9375rem auto 0;
  border-radius: .140625rem;
  overflow: hidden; 
  background: #23d0a5;  
}
.finish-btn>div{
  display: table-cell;
  vertical-align: middle;
}


.container >>> .photo-clip-mask{
  display: none;
}




.word-input-wrap{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
}
.word-input-wrap> .bg{
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.word-input-wrap>textarea{
  width: 100%;
  height: 9rem;
  background: transparent;
  font-size: 1rem;
  color: #fff;
  padding: .46875rem .9375rem;
  border: 0;

}
.text-confirm-wrap{
  position: fixed;
  width: 10rem;
  bottom: 0;
  left: 50%;
  margin-left: -5rem;
  background: #fff;
  height: 1rem;
  overflow: hidden;
}
.text-confirm{
  float: right;
  color: #fff;
  font-size: .34375rem;
  /* display: block; */
  background: #23d0a5;
  width: 1.40625rem;
  height: .6875rem;
  /* line-height: .6875rem; */
  text-align: center;
  margin-top: .1875rem;
  margin-right: .375rem;
  border-radius: .140625rem;
}

.canv_top{
  pointer-events: none;
}

.word-show{
  position: absolute;
  color:#fff;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  align-content: flex-end;
  -webkit-align-content: flex-end;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  height: 8.9rem;
  font-size: 1.125rem;
  text-align: center;
  padding: .46875rem 1.015625rem;
}
.word-show>>>.word-cont{
  display:inline-block;
  margin-bottom: .390625rem;
  -webkit-text-stroke: .03125rem #5ba3ed;
}
.word-show>>>.word-cont>div{
  display:inline-block;
}

.loading{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  flex-direction: column;
  -webkit-flex-direction: column;
}
.loading>img{
  width: 1.5625rem;
  margin-bottom: .46875rem;
}
.loading > span{
  color: #fafafa;
  font-size: .40625rem;
}

.btn-disable{
  background: #ccc;
}
.hide{
  display: none;
}
.is-show{
  display: block;
}
.w-active{
  color: #f9cd6a;
}

.visible-hide{
  visibility: hidden;
}

/* radomir */

.cbutton {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  position: absolute;
  display: inline-block;
  padding: 0;
  border: none;
  background: none;
  color: #286aab;
  font-size: 1.4em;
  overflow: visible;
  -webkit-transition: color 0.7s;
  transition: color 0.7s;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
  color: #3c8ddc;    
	box-shadow: inset 0 0 0 35px rgba(249,170,106,0);  
	-webkit-animation: anim-effect-radomir 0.5s ease-out forwards;
	animation: anim-effect-radomir 0.5s ease-out forwards;
}
@-webkit-keyframes anim-effect-radomir {
	0% {
		opacity: 1;
		-webkit-transform: scale3d(0.4, 0.4, 1);
		transform: scale3d(0.4, 0.4, 1);
	}
	80% {
		box-shadow: inset 0 0 0 2px rgba(249,170,106,0.8);
		opacity: 0.1;
	}
	100% {
		box-shadow: inset 0 0 0 2px rgba(249,170,106,0.8);
		opacity: 0;
		-webkit-transform: scale3d(1.2, 1.2, 1);
		transform: scale3d(1.2, 1.2, 1);
	}
}

@keyframes anim-effect-radomir {
	0% {
		opacity: 1;
		-webkit-transform: scale3d(0.4, 0.4, 1);
		transform: scale3d(0.4, 0.4, 1);
	}
	80% {
		box-shadow: inset 0 0 0 2px rgba(249,170,106,0.8);
		opacity: 0.1;
	}
	100% {
		box-shadow: inset 0 0 0 2px rgba(249,170,106,0.8);
		opacity: 0;
		-webkit-transform: scale3d(1.2, 1.2, 1);
		transform: scale3d(1.2, 1.2, 1);
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/ExpressionMany.vue